module.exports = __webpack_public_path__ + "img/suspendedAccount.c0b973b7.png";